// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"sidebar-module--sidebar--2YF0b","sidebar__link":"sidebar-module--sidebar__link--27nFE","sidebar__text":"sidebar-module--sidebar__text--2gsvz"};